import { TableField } from 'lib/context';

export enum HighlightsTableColumns {
  TITLE = 'title',
  HIGHLIGHT = 'highlight',
}

export enum HIGHLIGHTS_SORT_KEYS {
  TITLE = 'TITLE',
}

export const tableFields: TableField[] = [
  {
    value: HighlightsTableColumns.TITLE,
    label: 'Title',
    sortable: true,
    sortKey: HIGHLIGHTS_SORT_KEYS.TITLE,
  },
  {
    value: HighlightsTableColumns.HIGHLIGHT,
    label: 'Highlight',
    width: 306,
  },
];
